module.exports = __webpack_public_path__ + "static/img/liberal-victory.786f6ea.png";


//////////////////
// WEBPACK FOOTER
// ./src.common/assets/misc/liberal-victory.png
// module id = 261
// module chunks = 0